export default __webpack_public_path__ + "static/audible-d88b1ec4360e234661f425fcab48f931.png";